import {http} from '../index.js';

export const getReceipts = async () => {
  return http.get('/consumer/receipts').then((response) => response.data);
};

export const getMoreReceipts = async (url) => {
  return http.get(url).then((response) => response.data);
};
